import AxiosInstance from "./api";

export const CompanyService = {
  getAll: async () => {
    return await AxiosInstance.get("/super-admin/company/all");
  },
  paginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/super-admin/company?" + query.toString());
  },
  create: async (payload) => {
    return await AxiosInstance.post("/super-admin/company", payload);
  },
  getById: async (id) => {
    const { data } = await AxiosInstance.get("/super-admin/company/" + id);
    return data;
  },
  getByIdAdmin: async (id) => {
    const { data } = await AxiosInstance.get("/admin/company/" + id);
    return data;
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/super-admin/company/" + id, payload);
  },
  adminUpdate: async (id, payload) => {
    return await AxiosInstance.patch("/admin/company/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/super-admin/company/" + id);
  },
  getByAuth: async () => {
    return await AxiosInstance.get("/private/company/auth");
  },
};
